<template>
  <div class="event-form">
    <!-- Dynamic Alert for Displaying Messages -->
    <b-alert :show="!!responseMessage.message" :variant="responseMessage.type">
      {{ responseMessage.message }}
    </b-alert>
    <div class="form-group mb-3">
      <p class="primary">Last changed by: <strong>{{ userName }}</strong></p>
    </div>
    <b-form @submit.prevent="handleSubmit" class="row">
      <!-- Radio Button Column -->
      <div class="col-md-6">
        <b-form-group label="" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
                id="radio-group-1"
                v-model="eventType"
                :aria-describedby="ariaDescribedby"
                name="radio-options"
                required
            >
                <div v-for="option in options" :key="option.value" class="custom-radio">
                    <b-form-radio :value="option.value">{{ option.text }}</b-form-radio>
                </div>
            </b-form-radio-group>
        </b-form-group>
      </div>

      <!-- Comment and Inputs Column -->
      <div class="col-md-6 radio-container">
        <div class="form-group mb-3">
          <b-form-textarea
            id="comment"
            v-model="comment"
            rows="2"
            placeholder="Comment:"
            class="mb-2"
          ></b-form-textarea>
        </div>
        <div class="form-group mb-3">
            <div class="id-display-container">
                <p class="value-content"> ID 1: {{ id1 }}</p>
                <b-button @click="clearId1" variant="secondary" class="clear-button">
                    <b-icon icon="x-circle"></b-icon>
                </b-button>
            </div>
        </div>

        <div class="form-group mb-3">
            <div class="id-display-container">
                <p class="value-content"> ID 2: {{ id2 }}</p>
                <b-button @click="clearId2" variant="secondary" class="clear-button">
                    <b-icon icon="x-circle"></b-icon> 
                </b-button>
            </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="col-12">
        <b-button type="submit" variant="success" block>Submit</b-button>
      </div>
    </b-form>
  </div>
</template>


<script>
import { mapState,mapActions } from 'vuex';

export default {
  name: 'CommentWidget',
  data() {
    return {
      options: [
      { text: 'Splicing: cassette exon', value: 'Splicing: cassette exon' },
      { text: "Splicing: Alternative 5' splice site", value: "Splicing: Alternative 5' splice site" },
      { text: "Splicing: Alternative 3' splice site", value: "Splicing: Alternative 3' splice site" },
      { text: 'Splicing: retained intron', value:'Splicing: retained intron'},
      { text: 'Splciing: MXE', value:'Splciing: MXE'},
      { text: 'Splicing: other', value:'Splicing: other'},
      { text: 'Promoter usage', value:'Promoter usage'},
      { text: 'Alternative polyadenylation', value:'Alternative polyadenylation'},

      ]
    };
  },
  computed: {
    ...mapState({
      id1: state => state.commentDetails.id_1,
      id2: state => state.commentDetails.id_2,
      responseMessage: state => state.responseMessage,
      userName: state => state.commentDetails.user_name, // user who made the comment previously
    }),
    comment: {
        get() {
          return this.$store.state.commentDetails.comment;
        },
        set(value) {
          this.$store.dispatch('updateCommentDetail', { key: 'comment', value });
        }
      },
      eventType: {
        get() {
          return this.$store.state.commentDetails.event_type;
        },
        set(value) {
          this.$store.dispatch('updateCommentDetail', { key: 'event_type', value });
        }
  },
  },
  methods: {
    ...mapActions(['updateCommentDetail', 'clearCommentDetails']),
    handleSubmit() {
      this.updateCommentDetail({ key: 'comment', value: this.comment });
      this.updateCommentDetail({ key: 'event_type', value: this.eventType });
      if(this.eventType) {this.$emit('commentAdded')}; 
    },
    clearId1() {
      this.updateCommentDetail({ key: 'id_1', value: '' });
    },
    clearId2() {
      this.updateCommentDetail({ key: 'id_2', value: '' });
   }
  },
  
};
</script>

<style scoped>
.event-form {
  border: 1px solid #ccc;
  width: 900px; /* Increase width */
  padding: 10px; /* Reduce padding */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-radius: 8px;
  margin: 10px; /* Center the form */
}

.event-form .form-group {
  margin-bottom: 0.5rem; /* Reduce margin */
  display: flex;
  flex-direction: column;
}

.event-form label {
  margin-bottom: 0.3rem; /* Reduce margin */
  font-weight: bold;
}

.event-form .input-group {
  display: flex;
  align-items: center;
}

.event-form select {
  width: calc(100% - 50px); /* Adjust width to leave space for button */
  padding: 0.4rem; /* Reduce padding */
  border: 1px solid #ccc;
  border-radius: 4px 0 0 4px; /* Rounded corners on left side */
  font-size: 1rem;
}

.event-form .fab {
  width: 40px; /* Smaller button size */
  height: 40px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px; /* Smaller font size */
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
  margin-left: 10px; /* Overlap border */
}

.event-form .fab:hover {
  background-color: #0056b3;
}

.event-form textarea {
  width: 100%;
  padding: 0.4rem; /* Reduce padding */
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}
.id-display-container {
    display: flex;
    align-items: center;
    justify-content: space-between; 
    width: 100%; 
    padding: 5px; /* Provides some spacing inside the container */
    border-bottom: 1px solid #ccc; /* Adds a bottom border as in your design */
}

.value-display {
    font-weight: bold;
    margin-right: 10px; /* Adds spacing between the label and the value */
}

.value-content {
    margin: 0;
    margin-right: 20px; /* Adds spacing before the button */
    background-color: #f8f9fa;
    padding: 8px 10px 8px 8px; /* Consolidated padding */
    border-radius: 4px;
    border: 1px solid #ced4da;
    width: 100%; /* Set a fixed width */
    height: 40px; /* Set a fixed height */
    white-space: nowrap; /* Prevent text from wrapping */
    overflow: scroll; /* Hide overflow TOGGLE THIS*/
    /* text-overflow: ellipsis; Add ellipsis (...) */
}


.clear-button {
    white-space: nowrap; /* Prevents the button text from wrapping */
}

.id-display-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.custom-radio {
    display: block;
    margin-bottom: 0.5rem;
}

</style>
